import {
  TextField,
  Grid,
  Typography,
  Divider,
  Button,
  IconButton,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { getHourFromDate } from "../../../../common/helpers/utils";

export const formFields = [
  { name: "name", type: "text", label: "Emri i fushes" },
  { name: "length", type: "number", label: "Dimensionet (gjatësia)", min: 0 },
  { name: "width", type: "number", label: "Dimensionet (gjerësia)", min: 0 },
];

export const availableSportsLabels = [
  { label: "Futboll", name: "isFootball" },
  { label: "Basketboll", name: "isBasketball" },
  { label: "Tenis", name: "isTennis" },
  { label: "Volejboll", name: "isVolleyball" },
  { label: "Padel", name: "isPadel" },
];

export const slotRangeOptions = [
  { value: 60, label: "1 orë" },
  { value: 90, label: "1 orë e gjysëm" },
  { value: 120, label: "2 orë" },
];

export default function LocationForm({
  location,
  availableSports,
  slotRanges = slotRangeOptions,
  complexData,
  onFieldChange,
  onFieldTypeChange,
  onSlotRangeChange,
  onPriceRangeAdd,
  onPriceRangeRemove,
  onPriceRangeChange,
}) {
  // Helper function to get the selected field type from boolean flags
  const getSelectedFieldType = () => {
    if (location?.isFootball) return "isFootball";
    if (location?.isBasketball) return "isBasketball";
    if (location?.isTennis) return "isTennis";
    if (location?.isVolleyball) return "isVolleyball";
    if (location?.isPadel) return "isPadel";
    return "";
  };

  const priceRanges = location?.priceRanges || [];
  const minHour = getHourFromDate(complexData?.opensAt) || 1;
  const maxHour = getHourFromDate(complexData?.closesAt) || 24;

  const availableHours = [];
  for (let hour = minHour; hour <= maxHour; hour++) {
    availableHours.push({
      value: `${String(hour).padStart(2, "0")}:00`,
      label: `${String(hour).padStart(2, "0")}:00`,
    });
  }

 
  const getAvailableStartHours = (index) => {
    if (index === 0) return availableHours;
    
    const previousRange = priceRanges[index - 1];
    if (!previousRange || !previousRange.endTime) return availableHours;
    
    const previousEndHour = parseInt(previousRange.endTime.split(":")[0]);
    return availableHours.filter((hour) => {
      const hourValue = parseInt(hour.value.split(":")[0]);
      return hourValue >= previousEndHour;
    });
  };

  // Get available end hours based on start time
  const getAvailableEndHours = (startTime) => {
    if (!startTime) return availableHours;
    const startHour = parseInt(startTime.split(":")[0]);
    return availableHours.filter((hour) => {
      const hourValue = parseInt(hour.value.split(":")[0]);
      return hourValue > startHour;
    });
  };

  return (
    <>
      <React.Fragment>
        <Grid
          container
          alignItems="flex-start"
          justifyContent="space-between"
          m={2}
        >
          <Grid item xs={12} md={4}>
            {
            /* <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Fusha numer {_index + 1}
              </Typography> */
            }

            <Grid container spacing={2}>
              {formFields.map((input) => (
                <Grid item xs={12} key={input.label}>
                  <TextField
                    name={input.name}
                    label={input.label}
                    type={input.type}
                    inputProps={{ min: input.min ?? 0 }}
                    fullWidth
                    value={location?.[input.name] || ""}
                    onChange={(e) =>
                      onFieldChange(e.target.name, e.target.value)
                    }
                  />
                </Grid>
              ))}


            </Grid>
          </Grid>

          <Grid item xs={12} md={8}>
            <Grid container justifyContent="center" p={4}>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Zgjidhni llojin e fushës
                </Typography>
                <RadioGroup
                  value={getSelectedFieldType()}
                  onChange={(e) => onFieldTypeChange(e.target.value)}
                >
                  {availableSports.map((sport) => (
                    <FormControlLabel
                      key={sport.name}
                      value={sport.name}
                      control={<Radio />}
                      label={sport.label}
                    />
                  ))}
                </RadioGroup>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Zgjidhni kohëzgjatjen e seances
                </Typography>
                <RadioGroup
                  row
                  value={location?.slotRange}
                  onChange={(e) => onSlotRangeChange(+e.target.value)}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  {slotRanges.map((slot) => (
                    <FormControlLabel
                      key={slot.value}
                      value={slot.value}
                      control={<Radio />}
                      label={slot.label}
                    />
                  ))}
                </RadioGroup>
              </Grid>

               <Grid item md={10} sx={{ width: "500px" }}>
                 <Typography
                   variant="subtitle1"
                   sx={{ mt: 2, mb: 1, fontWeight: 600 }}
                 >
                   Çmimet sipas kohës
                 </Typography>

                 {!location?.slotRange && (
                   <Typography
                     variant="body2"
                     color="text.secondary"
                     sx={{ mb: 2, fontStyle: "italic" }}
                   >
                     Ju lutem zgjidhni kohëzgjatjen e seancës së parë
                   </Typography>
                 )}

                 {priceRanges.map((range, index) => (
                  <Box
                    key={index}
                    sx={{
                      mb: 2,
                      p: 2,
                      border: "1px solid #e0e0e0",
                      borderRadius: 1,
                      position: "relative",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                  

                     <Grid container spacing={1}>
                       <Grid item xs={4}>
                         <FormControl fullWidth >
                           <InputLabel>Nga ora</InputLabel>
                           <Select
                             value={range.startTime || ""}
                             onChange={(e) =>
                               onPriceRangeChange(
                                 index,
                                 "startTime",
                                 e.target.value
                               )
                             }
                             label="Nga ora"
                             disabled={index > 0 && !priceRanges[index - 1]?.endTime}
                           >
                             {getAvailableStartHours(index).map((hour) => (
                               <MenuItem key={hour.value} value={hour.value}>
                                 {hour.label}
                               </MenuItem>
                             ))}
                           </Select>
                         </FormControl>
                       </Grid>
                      <Grid item xs={4}>
                        <FormControl fullWidth>
                          <InputLabel>Deri ora</InputLabel>
                          <Select
                            value={range.endTime || ""}
                            onChange={(e) =>
                              onPriceRangeChange(
                                index,
                                "endTime",
                                e.target.value
                              )
                            }
                            label="Deri ora"
                            disabled={!range.startTime}
                          >
                            {getAvailableEndHours(range.startTime).map(
                              (hour) => (
                                <MenuItem key={hour.value} value={hour.value}>
                                  {hour.label}
                                </MenuItem>
                              )
                            )}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={4}>
                        <TextField
                          label="Çmimi"
                          type="number"
                          fullWidth
                          
                          value={range.price || ""}
                          onChange={(e) =>
                            onPriceRangeChange(index, "price", e.target.value)
                          }
                          inputProps={{ min: 0 }}
                        />
                      </Grid>
                    </Grid>

                    <IconButton
                      size="small"
                      onClick={() => onPriceRangeRemove(index)}
                      sx={{ position: "relative", right: -10, top: -10 }}
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                ))}

                 <Button
                   startIcon={<AddIcon />}
                   variant="outlined"
                   fullWidth
                   onClick={onPriceRangeAdd}
                   disabled={!location?.slotRange}
                   sx={{ mt: 1 }}
                 >
                   Shto segment kohor
                 </Button>
               </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Divider sx={{ my: 2 }} />
      </React.Fragment>
    </>
  );
}
